
export function replaceParams(
  url: string,
  params: { [key: string]: string | number | boolean; }
) {
  return url.replace(/:([a-zA-Z0-9]+)/g, (_, key) => {
    return params[key]?.toString();
  });
}
